export { default as LenisProvider } from './LenisProvider'
export * from './LenisProvider'
export * from './useLenis'
export * from './useLenisStore'
